import React, { useState } from 'react'

import * as Yup from 'yup'
import { Form, Input } from 'formik-antd'
import { Upload } from 'antd'

import { UploadOutlined } from '@ant-design/icons'

import { BasicForm } from '../../../../core/components/form'
import { useUpdateBrand, useFetch } from '../../../../hooks/admin/settings/brand'
import { useHistory } from 'react-router-dom'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required('Cannot be blank.'),
  address1: Yup.string().required('Cannot be blank.'),
  address2: Yup.string().required('Cannot be blank.'),
  email: Yup.string().email().typeError('Must be a valid email.')
})

function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

const Formulario = () => {
  const history = useHistory()
  const [logoImageUrl, setLogoImageUrl] = useState(null)
  const [loginImageUrl, setLoginImageUrl] = useState(null)
  const { data, isLoading, isError } = useFetch()
  const update = useUpdateBrand()

  function handleSubmit (values, bag) {
    const form = new FormData()
    form.append('name', values.name)
    form.append('address1', values.address1)
    form.append('address2', values.address2)
    form.append('email', values.email)
    form.append('logo', values.logo)
    form.append('login', values.login)

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues = {
    name: data?.name || '',
    address1: data?.address1 || '',
    address2: data?.address2 || '',
    email: data?.email || '',
    logo: data?.logo,
    login: data?.login
  }

  const validateImage = (file) => {
    /*
    agregar validaciones
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
        console.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        console.error("Image must smaller than 2MB!");
    }
    */

    // return false so that antd doesn't upload the picture right away
    return false
  }

  const handleLogoChange = (setFieldValue, info) => {
    const file = info.fileList[0]
    setFieldValue('logo', info.file)
    getBase64(file.originFileObj, (imageUrl) => setLogoImageUrl(imageUrl))
  }

  const handleLoginChange = (setFieldValue, info) => {
    const file = info.fileList[0]
    setFieldValue('login', info.file)
    getBase64(file.originFileObj, (imageUrl) => setLoginImageUrl(imageUrl))
  }

  const uploadButton = (
    <div>
      <UploadOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='BRAND'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={({ setFieldValue }) => (
        <>
          <Form.Item name='name' label='Name' required>
            <Input name='name' />
          </Form.Item>
          <Form.Item name='address1' label='Address Line 1' required>
            <Input name='address1' />
          </Form.Item>
          <Form.Item name='address2' label='Address Line 2' required>
            <Input name='address2' />
          </Form.Item>

          <Form.Item name='email' label='Email' required>
            <Input name='email' />
          </Form.Item>
          <Form.Item hidden name='logo' label='Logo' required>
            <Input name='logo' />
          </Form.Item>

          <Form.Item name='logo' label='Logo'>
            <Upload
              beforeUpload={validateImage}
              showUploadList={false}
              listType='picture-card'
              onChange={(e) => handleLogoChange(setFieldValue, e)}
              maxCount={1}
              accept='.png,.jpg,.jpge'
            >
              {logoImageUrl
                ? (<img src={logoImageUrl} alt='avatar' style={{ width: '100%' }} />)
                : data.logo
                  ? (<img alt='avatar' style={{ width: '100%' }} src={`${data.logo}`} />)
                  : (
                      uploadButton
                    )}
            </Upload>
          </Form.Item>

          <Form.Item name='login' label='Login'>
            <Upload
              beforeUpload={validateImage}
              showUploadList={false}
              listType='picture-card'
              onChange={(e) => handleLoginChange(setFieldValue, e)}
              maxCount={1}
              accept='.png,.jpg,.jpge'
            >
              {loginImageUrl
                ? (<img src={loginImageUrl} alt='avatar' style={{ width: '100%' }} />)
                : data.login
                  ? (<img alt='avatar' style={{ width: '100%' }} src={`${data.login}`} />)
                  : (uploadButton)}
            </Upload>
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
